import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isSite} from '../../../../../commons/selectors/environment'
import {useSettings} from '../../../hooks/settings'
import settingsParams from '../../../settingsParams'
import {useMembersPageActions, useMembersPageSelector} from '../../hooks/runtime'
import {getNoUpcomingEventsUrl} from '../../selectors/navigation'
import {Divider} from '../styled-components/divider'
import {NoEventsButton} from '../styled-components/no-events-button'
import {NoEventsText} from '../styled-components/no-events-text'
import s from './no-events.scss'

export const NoEvents = () => {
  const settings = useSettings()
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const site = useMembersPageSelector(isSite)
  const url = useMembersPageSelector(getNoUpcomingEventsUrl)

  const {navigateToNoUpcomingEventsUrl, seeOtherEvents} = useMembersPageActions()

  const onLinkClick = () => {
    if (!site) {
      navigateToNoUpcomingEventsUrl()
    }
    seeOtherEvents()
  }

  return (
    <div data-hook={DH.NO_EVENTS} className={isMobile ? s.mobile : null}>
      <div className={s.content}>
        <NoEventsText>{t('members-page.no-events.message')}</NoEventsText>
        <div className={s.button}>
          <NoEventsButton as="a" href={site ? url : null} onClick={onLinkClick} data-hook={DH.BUTTON_GO_TO_EVENTS}>
            {settings.get(settingsParams.noUpcomingEventsLink) as string}
          </NoEventsButton>
        </div>
      </div>
      <Divider />
    </div>
  )
}
